var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{ disabled: _vm.disabled },attrs:{"href":_vm.href},on:{"click":function($event){$event.preventDefault();!_vm.disabled && _vm.$router.push(_vm.to)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }